import { z } from 'zod';

export const TemplateWorkspaceSchema = z.object({
  templateIds: z.array(z.string()),
  currentTemplateId: z.string().nullable().optional(),
});

export type TemplateWorkspace = z.infer<typeof TemplateWorkspaceSchema>;
